// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smart-styling .Polaris-Badge--statusCritical {
  background-color: #FEDAD9;
  color: #8E1F0B;
  font-size: 12px;
}

.smart-styling .Polaris-Badge--statusInfo {
  background-color: #E0F0FF;
  color: #00527C;
  font-size: 12px;
}

.smart-styling .warning-max-times .Polaris-Badge--statusWarning {
  background-color: #FFFBF3;
  padding: 10px 16px;
  border-radius: 8px;
}

.smart-styling .warning-max-times .Polaris-Badge--statusWarning .Polaris-Icon__Img {
  height: 20px;
}

.smart-styling .warning-limit {
  display: flex;
  gap: 8px;
}

.smart-styling .warning-limit .Polaris-Button {
  width: 100%;
  background-color: #FFC96B;
  font-weight: 500;
  border: 0;
  box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;
  margin-top: 8px;
}

.smart-styling .link {
  display: inline-flex;
  gap: 2px;
  margin-bottom: 12px;
}

.smart-styling .link .Polaris-Link {
  display: inline-flex;
  gap: 2px;
  text-decoration: none;
  align-items: center;
}

.smart-styling .link .Polaris-Icon {
  margin: 0;
  position: relative;
  top: 1px;
}

.smart-styling .link .Polaris-Icon__Svg {
  width: 18px;
  height: 18px;
}

.smart-styling .fetch-url-instruction__label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.smart-styling .fetch-url-instruction__label .Polaris-Icon {
  width: 12px;
  height: 12px;
}

.smart-styling .source-option .Polaris-Badge--statusWarning {
  background-color: #FFF2D9;
  color: #FF3345;
  font-weight: 500;
  font-size: 12px;
}

.smart-styling .source-option--link {
  color: #202223;
}

.fetching-modal {
  text-align: center;
  padding: 20px 28px;
}

.fetching-modal .content-1 {
  font-weight: 600;
  font-size: 28px;
  padding-top: 24px;
}

.fetching-modal .content-2 {
  padding-top: 15px;
  color: #6d7175;
}

.smart-styling .button-group {
  padding-top: 10px;
}

.smart-styling .button-group .Polaris-Button:first-child {
  margin-right: 8px;
}

.smart-styling .button-group .Polaris-Button {
  width: 100%;
}

.btn-actions-applying {
  display: flex;
  justify-content: flex-end;
}

.applying-modal .content-1 {
  padding-bottom: 16px;
}

.fetch-url-instruction {
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/styles/smart-styling.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,uEAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".smart-styling .Polaris-Badge--statusCritical {\n  background-color: #FEDAD9;\n  color: #8E1F0B;\n  font-size: 12px;\n}\n\n.smart-styling .Polaris-Badge--statusInfo {\n  background-color: #E0F0FF;\n  color: #00527C;\n  font-size: 12px;\n}\n\n.smart-styling .warning-max-times .Polaris-Badge--statusWarning {\n  background-color: #FFFBF3;\n  padding: 10px 16px;\n  border-radius: 8px;\n}\n\n.smart-styling .warning-max-times .Polaris-Badge--statusWarning .Polaris-Icon__Img {\n  height: 20px;\n}\n\n.smart-styling .warning-limit {\n  display: flex;\n  gap: 8px;\n}\n\n.smart-styling .warning-limit .Polaris-Button {\n  width: 100%;\n  background-color: #FFC96B;\n  font-weight: 500;\n  border: 0;\n  box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;\n  margin-top: 8px;\n}\n\n.smart-styling .link {\n  display: inline-flex;\n  gap: 2px;\n  margin-bottom: 12px;\n}\n\n.smart-styling .link .Polaris-Link {\n  display: inline-flex;\n  gap: 2px;\n  text-decoration: none;\n  align-items: center;\n}\n\n.smart-styling .link .Polaris-Icon {\n  margin: 0;\n  position: relative;\n  top: 1px;\n}\n\n.smart-styling .link .Polaris-Icon__Svg {\n  width: 18px;\n  height: 18px;\n}\n\n.smart-styling .fetch-url-instruction__label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.smart-styling .fetch-url-instruction__label .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n.smart-styling .source-option .Polaris-Badge--statusWarning {\n  background-color: #FFF2D9;\n  color: #FF3345;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.smart-styling .source-option--link {\n  color: #202223;\n}\n\n.fetching-modal {\n  text-align: center;\n  padding: 20px 28px;\n}\n\n.fetching-modal .content-1 {\n  font-weight: 600;\n  font-size: 28px;\n  padding-top: 24px;\n}\n\n.fetching-modal .content-2 {\n  padding-top: 15px;\n  color: #6d7175;\n}\n\n.smart-styling .button-group {\n  padding-top: 10px;\n}\n\n.smart-styling .button-group .Polaris-Button:first-child {\n  margin-right: 8px;\n}\n\n.smart-styling .button-group .Polaris-Button {\n  width: 100%;\n}\n\n.btn-actions-applying {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.applying-modal .content-1 {\n  padding-bottom: 16px;\n}\n\n.fetch-url-instruction {\n  white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
